import { actionStorageMax, actionStorageMin } from "./computeRequirements";

export const isActionNameValid = (name: string) => {
  const regex = /^[a-zA-Z0-9_-]+$/;
  if (name && name.length > 0) {
    return regex.test(name);
  }
  return true;
};

export const isActionImageValid = (image: string | null) => {
  const regex = /.+:.+/;
  if (image && image.length > 0) {
    return regex.test(image);
  }
  return true;
};

export const actionNameError = (name: string | undefined) => {
  return name !== undefined && !isActionNameValid(name);
};

export const actionImageError = (image: string | null | undefined) => {
  return image !== undefined && !isActionImageValid(image);
};

export const actionStorageError = (
  storage: number | undefined,
  storageLimit = actionStorageMax,
) => {
  return storage !== undefined && !isActionStorageValid(storage, storageLimit);
};

export const isActionStorageValid = (
  storage: number,
  storageLimit?: number,
) => {
  if (
    storage < actionStorageMin ||
    storage > (storageLimit || actionStorageMax)
  ) {
    return false;
  }
  return true;
};

export const parseTimeout = (timeout: number | string) => {
  return parseInt(timeout.toString());
};

export const isActionTimeoutValid = (
  timeout: number | string | undefined | null,
) => {
  if (timeout === undefined || timeout === null) {
    // Timeout is optional, it is defaulted on the backend at invocation.
    return true;
  }
  const parsed = parseTimeout(timeout);
  if (Number.isNaN(parsed) || parsed < 1 || parsed > 720) {
    return false;
  }
  return true;
};
